import React from "react"
import HeroContent from "./hero-content"
import ScrollAnimation from "react-animate-on-scroll"
import HeroImgDesktop from "./mobile-first-img-desktop"
import HeroImgMobile from "./mobile-first-img-mobile"
import MobileFirstPageStyle from "./mobile-first-page.module.scss"

const Hero = () => (
    <div className={MobileFirstPageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop />
            <HeroImgMobile />
        </ScrollAnimation>
        <HeroContent />
    </div>
)

export default Hero